<template>
    <div v-if="affiliateData" class="affiliate_box" :class="`${affBannerDisplay ? 'show' : ''} ${isMobile ? 'isMobile' : ''}`">
        <template v-if="isMobile && affiliateData?.mobile_img.length">
            <button @click="closeAffiliateBanner" type="button" class="affiliate_close" :aria-label="$t('close')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" aria-hidden="true">
                    <path id="Path_94648" data-name="Path 94648" d="M10,1.819,8.181,0,5,3.181,1.819,0,0,1.819,3.181,5,0,8.181,1.819,10,5,6.819,8.181,10,10,8.181,6.819,5Z" transform="translate(10 10) rotate(180)" />
                </svg>
            </button>
            <div class="affiliate_container">
                <img :src="affiliateData.mobile_img" alt="affiliate-mobile" class="affiliate_img" @click="goPage">
            </div>
        </template>
        <template v-else-if="!isMobile && affiliateData?.img">
            <button @click="closeAffiliateBanner" type="button" class="affiliate_close" :aria-label="$t('close')">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" aria-hidden="true">
                    <path id="Path_94648" data-name="Path 94648" d="M10,1.819,8.181,0,5,3.181,1.819,0,0,1.819,3.181,5,0,8.181,1.819,10,5,6.819,8.181,10,10,8.181,6.819,5Z" transform="translate(10 10) rotate(180)" />
                </svg>
            </button>
            <div class="affiliate_container">
                <img :src="affiliateData.img" alt="affiliate-desktop" class="affiliate_img" @click="goPage">
            </div>
        </template>
    </div>
</template>

<script setup>
const { isMobile } = useDevice();
const { t } = useI18n();
const config = useRuntimeConfig();
const route = useRoute()
const dashboardStore = useDashboardStore()
const affiliateData = computed(() => {
    if (!dashboardStore.ready || !dashboardStore.data.Affbanner) {
        return null
    }
    return dashboardStore.data.Affbanner;
})

const goPage = (e) => {
    if (affiliateData.value.display == 'current') {
        window.location.href = affiliateData.value.link;
    } else {
        window.open(affiliateData.value.link, '_blank');
    }
}

const affBannerDisplay = ref(false);
const affBannerTime = ref(0);
const closeAffiliateBanner = (e) => {
    var getTomorrowTime = Math.floor(Date.now() / 1000) + 86400;
    window.localStorage.setItem("affBannerDisplayTime", getTomorrowTime);
    affBannerDisplay.value = false;
}

onMounted(() => {
    var getAffBannerTime = window.localStorage.getItem('affBannerDisplayTime');
    var getCurrentTime = Math.floor(Date.now() / 1000);
    if (getAffBannerTime) {
        if (getCurrentTime < getAffBannerTime) {
            affBannerDisplay.value = false;
        } else {
            affBannerDisplay.value = true;
        }
    } else {
        affBannerDisplay.value = true;
    }
})
</script>


<style scoped>
.affiliate_box {
    width: 500px;
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    text-align: right;
    display: none;
    z-index: 10;
}
.affiliate_box.isMobile {
    bottom: 70px;
}
.affiliate_box.show {
    display: block;
}
.affiliate_close {
    width: 15px;
    height: 15px;
}
.affiliate_close svg {
    width: 100%;
    height: 100%;
}
.affiliate_close svg path {
    fill: var(--text-base);
}
.affiliate_container {
    border-radius: 10px;
    overflow: hidden;
}
.affiliate_img {
    width: 100%;
    cursor: pointer;
}

@media (max-width: 767px) {
    .affiliate_box {
        width: 300px;
    }
}
</style>
